import { Link } from 'react-router-dom';
import { Building2 } from 'lucide-react';

export default function Settings() {
  return (
    <div className="space-y-6" data-testid="settings-page">
      <div>
        <h1 className="text-2xl font-bold text-slate-900">Settings</h1>
        <p className="text-slate-500">Manage your account and preferences</p>
      </div>

      <div className="bg-white rounded-xl border border-slate-200 p-6">
        <div className="text-center py-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-indigo-600 to-violet-600 rounded-xl mb-4">
            <Building2 className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-xl font-semibold text-slate-900">Altam™ Demo Instance</h2>
          <p className="text-slate-500 mt-2">This is a demo environment for evaluation purposes.</p>
          <p className="text-slate-500">Settings modifications are disabled in demo mode.</p>
          
          <div className="mt-6 p-4 bg-amber-50 border border-amber-200 rounded-lg inline-block text-left">
            <p className="text-sm text-amber-800"><strong>Note:</strong> In production, you would be able to configure:</p>
            <ul className="text-sm text-amber-700 mt-2 list-disc list-inside">
              <li>User profile settings</li>
              <li>Notification preferences</li>
              <li>Security settings (2FA, password)</li>
              <li>Company branding</li>
              <li>Integration settings</li>
              <li>CRA remittance preferences</li>
              <li>Email templates</li>
            </ul>
          </div>

          <div className="mt-6">
            <Link to="/dashboard" className="inline-flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-indigo-600 to-violet-600 text-white rounded-lg">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
